<template>
  <div style="width:40%;display: flex;flex-direction: column;position: relative;">
    <span style="line-height: 30px;font-size: 18px;" class="tip-icon"> 分配菜单 </span>
    <div style="display: flex; flex-direction: row; padding-left: 90px;position: absolute;right: 0;">
      <a-button key="submit" type="primary" @click="save" style="margin-right: 10px;">保存</a-button>
      <a-button type="primary" ghost @click="showReturn">返回上级菜单</a-button>
    </div>
    <div style="height: 70vh;overflow-y: scroll;margin-top: 40px;">
      <div on-ok="save">
        <div>
          <a-tree v-if="data.length" v-model="checkedKeys" :checkable="checkable" :defaultExpandAll="true"
            @check="onCheck" :tree-data="data" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { queryMenu, fenpeiMenu, roleuser, menuList } from "@/api/api.js";
export default {
  data() {
    return {
      data: [],
      bNode: [],//菜单列表树的所有底层结点
      alltreeData: [],//菜单列表树的所有结点
      checkedKeys: [],
      checkable: true,
      flatArr: [],
      menuTreeSelectKeys: [],
    };
  },
  mounted() {
    this.bNode = []
    this.checkedKeys = []
    this.searchList();
    this.queryreal();
  },
  watch: {
    checkedKeys: {
      handler(n, old) {
      }
    }
  },
  methods: {
    //返回
    showReturn() {
      this.$router.go(-1);
    },
    //复选框
    onCheck(checkedKeys, e) {
      this.menuTreeSelectKeys = checkedKeys.concat(e.halfCheckedKeys);
    },
    searchList() {
      let pageParam = {
        pageNum: 0,
        pageSize: 0,
        orderBy: "",
      };
      menuList({ pageParam: pageParam }).then((res) => {
        this.getTreemenu(res.content, 0);
      });
    },
    // 树型菜单列表获取
    getTreemenu(data, parentId) {
      var treeMenu = [];
      for (var i = 0; i < data.length; i++) {
        var node = data[i];
        if (data[i].parentId == parentId) {
          var newTree = {
            key: node.id,
            title: node.menuName,
            mlink: node.menuLink,
            children: this.getTreemenu(data, node.id),
          };
          treeMenu.push(newTree);
        }
      }
      this.data = treeMenu;
      return treeMenu;
    },
    //查询指定角色的菜单列表
    queryreal() {
      this.id = this.$route.query.id;
      let obj = {
        pageParam: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          orderBy: "",
        },
        content: {
          id: this.id,
        },
      };
      const list = [];
      const SelectList = [];
      queryMenu(obj).then(
        (res) => {
          this.searchBnode(this.data[0].children)
          this.alltreeData.splice(0)
          res.content.rows.forEach((element) => {
            this.alltreeData.push(element.id);
          });
        },
        (err) => { }
      ).then((res) => {
        this.filterNode(this.alltreeData, this.bNode)
      })
    },
    filterNode(bNode, alltreeData) {
      const ubNode = alltreeData.map((i) => {
        const index = bNode.indexOf(i);
        if (index == -1) {
          return bNode[index]
        }
        return i
      })
      ubNode.forEach(element => {
        if (element) {
          this.checkedKeys.push(element)
        }
      });
    },
    // 查询所有底层结点
    searchBnode(node) {
      for (let item of node) {
        if (item.children && item.children.length) {
          this.searchBnode(item.children)
        } else {
          this.bNode.push(item.key)
        }
      }
      return this.bNode
    },
    //保存
    save() {
      this.id = this.$route.query.id;
      if (this.menuTreeSelectKeys.length > 0) {
        fenpeiMenu({
          menuIds: this.menuTreeSelectKeys,
          roleId: this.id,
        }).then(
          (res) => {
            this.$message.success("保存成功");
            this.$router.go(-1);
          },
          (err) => {
            this.$message.error(err.message)
          }
        );
      } else {
        this.$message.error("请勾选为角色分配的菜单")
      }
    },
  }
}
</script>
<style lang="less" scoped="scoped">
.btthree {
  width: 120px;
  margin-left: 10px;
}

.tree-box {
  width: 100%;

  height: 650px;

  overflow: auto;
  /* 滚动条设置 */
  margin-bottom: 50px;
}
</style>